import { render, staticRenderFns } from "./PhoneVideo.vue?vue&type=template&id=6c19f33c&scoped=true&"
import script from "./PhoneVideo.vue?vue&type=script&lang=js&"
export * from "./PhoneVideo.vue?vue&type=script&lang=js&"
import style0 from "./PhoneVideo.vue?vue&type=style&index=0&id=6c19f33c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c19f33c",
  null
  
)

export default component.exports